import { styled as o, excludeProps as d } from "@lokalise/styled";
import { value as i } from "../../utils/theme/index.js";
const e = o.div.withConfig({
  shouldForwardProp: d(["radius", "size"])
})`
	height: ${({ size: r }) => r}px;
	width: ${({ size: r }) => r}px;
	border-radius: 50%;
	background-color: ${i("color.background.disabled")};
`;
e.displayName = "Circle";
export {
  e as Circle
};
//# sourceMappingURL=Circle.js.map
